import { render, staticRenderFns } from "./slide-x-item.vue?vue&type=template&id=6e59819f&scoped=true&"
import script from "./slide-x-item.vue?vue&type=script&lang=js&"
export * from "./slide-x-item.vue?vue&type=script&lang=js&"
import style0 from "./slide-x-item.vue?vue&type=style&index=0&id=6e59819f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e59819f",
  null
  
)

export default component.exports